import { TmFormError } from '@/core/error/tmFormError'

export class TmFormHasBeenDestroyedBeforeSubmitCompletedError extends TmFormError {
  public name = 'tmFormHasBeenDestroyedBeforeSubmitCompletedError'
}
